import React, { useState, Fragment, useEffect } from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { Controller, useForm } from 'react-hook-form';
import { useLoginFormStyle } from './useLoginFormStyles';
import MyEirToggleBtn from './MyEirToggleBtn';
import {
    Grid,
    TextField,
    Container,
    Button,
    Icon,
    Paper,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import EirModal from '../eir-modal/EirModal';
import Loading from '.././shared/Loading';
import { setTimeout } from 'core-js';

const theme = createMuiTheme({
    typography: {
        textTransform: 'none',
        textAlign: 'left',
        letterSpacing: '0px',
        fontFamily: 'gt-walsheim-regular !important',
        fontSize: '1rem !important',
        opacity: 1,
        fontSize: '1rem',
    },
    palette: {
        primary: {
            main: '#892BA0',
        },
    },
    overrides: {
        MuiFormControlLabel: {
            label: {
                '@media (max-width: 1024px)': {
                    fontSize: '14px',
                },
            },
        },
        MuiFormLabel: {
            asterisk: {
                color: '#f44336;',
            },
        },
        MuiTextField: {
            root: {
                fontSize: '16px',
                color: 'black',
                '@media (max-width: 1024px)': {
                    fontSize: '14px',
                },
            },
        },
        MuiInputLabel: {
            root: {
                color: 'black',
                fontSize: '16px',
                '@media(max-width: 1024px)': {
                    fontSize: '14px',
                },
            },
        },
        MuiContainer: {
            root: {
                padding: '0px'
            }

        }
    },
});

function EirLogin(props) {

    const classes = useLoginFormStyle();
    const { register, control, errors, handleSubmit, setValue } = useForm({
        mode: 'onChange',
    });
    const [loginError, setLoginError] = useState(false);
    const methods = useForm({ mode: 'onChange' });
    const [emailAddress, setEmailAddress] = useState('');
    const [password, setPassword] = useState('');
    const [rememberPwd, setrememberPwd] = useState(false);
    const [LoginErrorText, setLoginErrorText] = useState('');
    const [existingTVCustModal, setExistingTVCustModal] = useState(false);
    const [continueToPrequal, setContinueToPrequal] = useState(false);
    const toggle = props.toggle;
    const setLoginSuccess = props.setLoginSuccess;
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const validateExistingCust = document.createElement("script");
        validateExistingCust.src = "/opencms/export/system/modules/net.eir.opencms/resources/js/external/modules/m58-upgrade-eligibility-check-form/m58-upgrade-eligibility-check-form.js";
        validateExistingCust.async = true;
        document.getElementsByTagName("head")[0].appendChild(validateExistingCust);
        if (continueToPrequal) {
            location.href = "/tv/checkyourline/";
        }
        return () => {
            document.getElementsByTagName("head")[0].removeChild(validateExistingCust);
        }
    }, [continueToPrequal])

    //function to delete cookie - 
    const deleteCookie = (cookieName, cookieValue, expiryTime) => {
        var d = new Date();
        d.setTime(d.getTime() + (expiryTime * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
    }

    const onSubmit = data => {
        setIsLoading(true);
        sessionStorage.removeItem('existingCustomerBundleDetails');
        localStorage.setItem("existingCustomerstatus", "");
        setLoginSuccess(false);
        //console.log("====data===", data);
        setLoginError(false);
        setLoginErrorText('');
        //console.log("m58.settings.r6.server >> ", m58.settings.r6.server);
        //call logIn function from the script included above -- validateExistingCust (from sales frontend)
        let resp = m58.form.r6.logIn();
        //console.log("Auth resp", resp);
        setTimeout(() => {
            var auth_status = localStorage.getItem("existingCustomerstatus");
            if (auth_status == "auth_err") {
                setLoginError(true);
                setLoginErrorText('Invalid user credentials');
                setIsLoading(false);
            }

            else {
                setTimeout(() => {
                    setLoginError(false);
                    //get the r6Key for the BB product
                    var getExistingCustomerInternetKey = "";
                    var getExistingCustomerVoiceKey = "";
                    var getExistingCustomerMobileKey = "";
                    var getExistingCustomerTVKey = "";
                    var getExistingCustomerBundleDetails = JSON.parse(sessionStorage.getItem("existingCustomerBundleDetails")) ? ((JSON.parse(sessionStorage.getItem("existingCustomerBundleDetails")).data.bundles != null) && JSON.parse(sessionStorage.getItem("existingCustomerBundleDetails")).data.bundles.bundles[0]) : '';
                    // getExistingCustomerBundleDetails;
                    if (!(location.href.indexOf("/checkout/customer-details") > 0) && getExistingCustomerBundleDetails != undefined && getExistingCustomerBundleDetails != null) {
                        for (var i = 0; i < getExistingCustomerBundleDetails.subProducts.length; i++) {
                            if (getExistingCustomerBundleDetails.subProducts[i].subProductType === "INTERNET") {
                                getExistingCustomerInternetKey = getExistingCustomerBundleDetails.subProducts[i].subProductName;
                            } else if (getExistingCustomerBundleDetails.subProducts[i].subProductType === "FIXED_LINE") {
                                getExistingCustomerVoiceKey = getExistingCustomerBundleDetails.subProducts[i].subProductName;
                            } else if (getExistingCustomerBundleDetails.subProducts[i].subProductType === "MOBILE") {
                                getExistingCustomerMobileKey = getExistingCustomerBundleDetails.subProducts[i].subProductName;
                            } else if (getExistingCustomerBundleDetails.subProducts[i].subProductType === "TV") {
                                getExistingCustomerTVKey = getExistingCustomerBundleDetails.subProducts[i].subProductName;
                            }
                        }
                        //console.log("getExistingCustomerInternetKey >>", getExistingCustomerInternetKey);
                    }
                    if (getExistingCustomerInternetKey == "") {
                        if (location.href.indexOf("/checkout/customer-details") > 0) {
                            setLoginSuccess(true);
                            setIsLoading(false);
                            toggle();
                        }
                        else {
                            location.href = "/broadband";
                        }
                    }
                    else {
                        if (location.href.indexOf("/checkout/customer-details") > 0) {
                            setLoginSuccess(true);
                            setIsLoading(false);
                            toggle();
                        }
                        else {
                            var getBundleCodeFromResponse = "";
                            var params = "BROADBANDPLAN_R6_KEY=" + getExistingCustomerInternetKey + "&VOICEPLAN_R6_KEY=" + getExistingCustomerVoiceKey;
                            if (getExistingCustomerMobileKey != "") params = params + "&MOBILEPLAN_R6_KEYS=" + getExistingCustomerMobileKey;
                            if (getExistingCustomerTVKey != "") params = params + "&TVPLAN_R6_KEY=" + getExistingCustomerTVKey;
                            //console.log("params for fetchng existingCustomerBundle >>>  ", params);
                            //setTimeout(() => {
                            fetch('/store/api/bundleSummary/existingCustomerBundle/?' + params).then((response) => {
                                if (response.ok) {
                                    //console.log("response >>>>>>>>>>> ", response);
                                }
                                return response.json();
                            })
                                .then((data) => {
                                    if (data.pruned && data.type == "FTTH") {//logic 2
                                        setOverlayCopy1("To add TV you will need to switch broadband plans.");
                                        setCta1text("");
                                        setCta2text("Continue");
                                        setExistingTVCustModal(true);
                                    }
                                    if (data.pruned && data.type == "FTTC" && data.eligibility == "FTTH") {//logic 3
                                        setOverlayCopy1("To add TV you will need to switch broadband plans. Why not upgrade your home to speeds of 1Gb.");
                                        setCta1text("");
                                        setCta2text("Continue");
                                        setExistingTVCustModal(true);
                                        $('.tv-existingCustomer-modal-outer .Overlay').css("width", "80%"); // aligning the overlay copy in the modal
                                    }

                                    if (!data.pruned && data.type == "FTTC" && data.eligibility == "FTTH") {//logic 4
                                        setOverlayCopy1("Gigabit Fibre is here! Why not upgrade your home to speeds of 1Gb.");
                                        setCta1text("Continue to checkout");
                                        setCta2text("Show fibre plans");
                                        setExistingTVCustModal(true);
                                        $('.tv-existingCustomer-modal-outer').addClass('existingCustomer-modal'); // aligning the overlay copy in the modal
                                    }
                                    getBundleCodeFromResponse = data.bundleOffer;
                                    //console.log("getBundleCodeFromResponse >>>>>>>> ", getBundleCodeFromResponse);
                                    setLoginErrorText('Login Successful and BB r6 key is ', getExistingCustomerInternetKey);
                                    //get the bundle code returned from the response and now trigger the prequal in the background
                                    var getExistingCustomerPhone = JSON.parse(localStorage.getItem("existingCustomerAccountDetails")).data.fixedAccount.telephoneNumber;
                                    var setPrequalLocationType = "number";
                                    //console.log("getExistingCustomerPhone >>>> ", getExistingCustomerPhone);
                                    $.cookie("eir_clicked_bundle_code", getBundleCodeFromResponse, { path: '/' });
                                    $.cookie("eir_clicked_context_id", getBundleCodeFromResponse, { path: '/' });
                                    $.cookie("eir_prequal_user_location_type", setPrequalLocationType, { path: '/' });
                                    $.cookie("eir_prequal_user_location", getExistingCustomerPhone, { path: '/' });
                                })
                                .catch((error) => {
                                    console.log("error >>>>>>>>>>>>>>>>>> ", error)
                                });
                            // }, 5000);
                        }
                    }
                }, 30000);
            }
        }, 4000);
    }

    const handleChange = event => {
        setrememberPwd(event.target.checked);
        setValue('rememberPwd', event.target.checked);

        return event.target.value;
    };
    const handleValueChange = event => {
        setLoginError(false);
        setLoginErrorText('');
        return event.target.value;
    };
    // for existingTVCustModal
    const handleToggle = () => {
        setExistingTVCustModal(!existingTVCustModal);
    }
    // for existingTVCustModal
    const handleContinueToPrequal = () => {
        setContinueToPrequal(true);
    }

    const OverlayHeading = "";
    const OverlayCopy2 = " Click to continue. ";
    const cta1type = "button";
    const [cta1text, setCta1text] = useState('');
    const [cta1title, setCta1title] = useState('');
    // const cta1onClick = ;
    const cta2type = "button";
    const [cta2text, setCta2text] = useState('Continue');
    const [cta2title, setCta2title] = useState('Continue');
    const [OverlayCopy1, setOverlayCopy1] = useState('');
    // const cta2onClick = ;
    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <div className={classes.loginForm}>
                    <Container className='eirLoginContainer'>
                        <div className='formHolder'>
                            <Paper className={classes.paper}>
                                <div className='formLogoSection'>
                                    <img src='/opencms/export/system/modules/my.portal.opencms/myeir_ion/images/my-eir-logo-white-small.png'></img>
                                </div>
                                <div className="LoginText ">
                                    <p className="Login__header d-flex justify-content-center align-items-center">Log in or register</p>
                                    <p className="Login__subtext d-flex justify-content-center align-items-center">Please log in to your my eir account to purchase as an existing customer</p>
                                </div>
                                <MyEirToggleBtn></MyEirToggleBtn>

                                <Container>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={12}>
                                                <div className="mb-3">
                                                    <Controller
                                                        as={
                                                            <TextField
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <EmailOutlinedIcon className='Icon' />
                                                                    ),
                                                                }}
                                                            />
                                                        }
                                                        onChange={([event]) => {
                                                            handleValueChange(event);
                                                            return event.target.value;
                                                        }}
                                                        required
                                                        control={control}
                                                        fullWidth
                                                        id='tvExistingCustomerEmailAddress'
                                                        name='tvExistingCustomerEmailAddress'
                                                        label='Email address'
                                                        variant='outlined'
                                                        size='small'
                                                        placeholder='Email Address'
                                                        InputLabelProps={{ shrink: true }}
                                                        // inputRef={register}
                                                        defaultValue={emailAddress}
                                                        rules={{
                                                            required: true,
                                                            pattern: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
                                                        }}
                                                    />
                                                </div>
                                                {errors.tvExistingCustomerEmailAddress &&
                                                    errors.tvExistingCustomerEmailAddress.type === 'required' && (
                                                        <span className='errorMessage err_align'>
                                                            Please enter a valid email address
                                                        </span>
                                                    )}
                                                {errors.tvExistingCustomerEmailAddress &&
                                                    errors.tvExistingCustomerEmailAddress.type === 'pattern' && (
                                                        <span className='errorMessage err_align'>
                                                            Please enter a valid email address
                                                        </span>
                                                    )}
                                            </Grid>
                                            {/* <a href='/prepay/forgot-email' className='forgotLink'>
                                                I forgot my email address ‣
                                            </a> */}
                                        </Grid>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={12}>
                                                <div>
                                                    <Controller
                                                        as={
                                                            <TextField
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <LockOutlinedIcon className='Icon' />
                                                                    ),
                                                                }}
                                                            />
                                                        }
                                                        onChange={([event]) => {
                                                            handleValueChange(event);
                                                            return event.target.value;
                                                        }}
                                                        required
                                                        control={control}
                                                        fullWidth
                                                        type='password'
                                                        id='tvExistingCustomerPassword'
                                                        name='tvExistingCustomerPassword'
                                                        label='Password'
                                                        variant='outlined'
                                                        size='small'
                                                        placeholder='password'
                                                        InputLabelProps={{ shrink: true }}
                                                        // inputRef={register}
                                                        defaultValue={password}
                                                        rules={{
                                                            required: true,
                                                            // pattern: /^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[a-z]).{8,}$/,
                                                        }}
                                                    />
                                                </div>
                                                {errors.tvExistingCustomerPassword &&
                                                    errors.tvExistingCustomerPassword.type === 'required' && (
                                                        <span className='errorMessage'>
                                                            Please enter a password
                                                        </span>
                                                    )}
                                                {errors.tvExistingCustomerPassword &&
                                                    errors.tvExistingCustomerPassword.type === 'pattern' && (
                                                        <span className='errorMessage'>
                                                            Please enter a password
                                                        </span>
                                                    )}
                                            </Grid>
                                            <a
                                                href='https://my.eir.ie/bundles/forgotten-email' target="_blank"
                                                className='forgotLink'
                                            >
                                                I forgot my login details ‣
                                            </a>
                                        </Grid>
                                        {/* <Grid container spacing={2} className='text-left'>
                                            <Grid item xs={12}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            // checked={allowEmail}
                                                            color='primary'
                                                            id='rememberpwd'
                                                            inputRef={register}
                                                            name='rememberpwd'
                                                            onChange={() => handleChange(event)}
                                                        />
                                                    }
                                                    label='Remember my email address'
                                                />
                                            </Grid>
                                        </Grid> */}
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={12}>
                                                <div>
                                                    {loginError && (
                                                        <span
                                                            className='errorMessage'
                                                            style={{
                                                                marginTop: '0px',
                                                                marginBottom: '1.25rem',
                                                            }}
                                                        >
                                                            {LoginErrorText}
                                                        </span>
                                                    )}
                                                </div>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={12}>
                                            <div className='mobileFloat mt-3 mb-3'>
                                                {isLoading &&
                                                    <Loading className="m-5" />
                                                }
                                                {!isLoading && <Button
                                                    onClick={handleSubmit(onSubmit)}
                                                    type='submit'
                                                    className='loginBtn'
                                                >
                                                    Log in <span className='fontLarge'></span>
                                                </Button>}
                                                {/* <input
                                                    type='button'
                                                    value='Log in'
                                                    className='loginBtn'
                                                    // onClick={handleCancle}
                                                /> */}
                                            </div>
                                        </Grid>
                                    </form>
                                </Container>
                            </Paper>
                        </div>
                    </Container>
                </div>
            </ThemeProvider>
            <EirModal
                className="tv-existingCustomer-modal-outer"
                centered={true}
                Modal={existingTVCustModal}
                handleToggle={handleToggle}
                img={"/opencms/export/sites/default/.galleries/business/3-6-Column/smb-plus-circle.png"}
                OverlayHeading={OverlayHeading}
                OverlayCopy1={OverlayCopy1}
                OverlayCopy2={OverlayCopy2}
                cta1={true}
                cta1outline={true}
                cta1type={cta1type}
                cta1text={cta1text}
                cta1title={cta1title}
                // cta1onClick={cta1onClick}
                cta2={true}
                cta2outline={true}
                cta2type={cta2type}
                cta2text={cta2text}
                cta2title={cta2title}
                cta2onClick={handleContinueToPrequal}
            ></EirModal>
        </Fragment>
    );
}

export default EirLogin;